import * as UI from "./liveavatar-ui.js";
import * as API from "./liveavatar-api-client.js";
import * as LiveKit from "./liveavatar-livekit.js";
import { startAvatarChromaKey } from "./liveavatar-background.js";

let isLoading = false;

const API_URL = API.API_URL;

/**
 * La sessione con l'avatar va aperta una volta sola: qui viene conservata la relativa attesa, così sia
 * il pulsante di avvio sia una scorciatoia possono dipendere dalla stessa connessione senza coordinarsi.
 */
let attesaSessione = null;
// manca l'id sessione da passare al backend per chiudere, la funzione da usare si chiama terminaSessione()

UI.elements.pulsanteAvviaChat.addEventListener("click", () => avviaChat());
UI.elements.pulsanteInvia.addEventListener("click", () => preparaEInviaMessaggio());
UI.elements.pulsanteTerminaChat.addEventListener("click", () => terminaChat());
UI.elements.messageInput.addEventListener("keypress", (e) => {
    if (e.key === "Enter") {
        UI.elements.messageInput.disabled = true;
        preparaEInviaMessaggio();
    }
});

/**
 * 1. Avvio della sessione. Al primo utilizzo esegue la richiesta, dalle volte successive restituisce
 * l'attesa già in corso o già conclusa senza aprire una seconda sessione.
 * @returns true se la sessione è utilizzabile, false altrimenti
 */
function avviaSessione() {
    if (!attesaSessione) {
        attesaSessione = connettiAvatar();
    }

    return attesaSessione;
}

/**
 * Richiesta della sessione a LiveAvatar e connessione alla stanza, seguendo il flusso imposto dalle api:
 * il controller recupera avatar, token e sessione, e restituisce le coordinate della stanza LiveKit.
 * @returns true se la stanza è stata aperta correttamente, false altrimenti
 */
async function connettiAvatar() {
    // Predispone lo stato grafico iniziale degli elementi
    UI.initUI();

    console.log("avvia chat");

    try {
        UI.setChatState("starting");

        const sessione = await API.startSession();

        console.log(sessione);

        UI.setChatState("connecting");

        const { livekit_url, livekit_client_token } = sessione;

        // Avviamo e connettiamo la stanza LiveKit passando i comportamenti desiderati
        await LiveKit.connettiLiveKit(livekit_url, livekit_client_token, {
            onTrackSubscribed: (track) => {
                if (track.kind === "video" && UI.elements.videoElement) {
                    track.attach(UI.elements.videoElement);
                    UI.elements.videoElement.addEventListener(
                        "loadeddata",
                        () => {
                            //rimozione immagine di placeholder e inserimento immagine personalizzata
                            document.getElementById("avatarContainer").style.backgroundImage = "url('https://appmanager.fatherswatches.com/immagini/altro/sfondo-avatar.jpg')";
                            document.querySelector(".fw-concierge__media-gradient").style.display = "none";
                            startAvatarChromaKey();
                        },
                        { once: true }
                    );
                    UI.setChatState("active");

                    console.log("connesso");
                }
                if (track.kind === "audio") {
                    const audioElement = track.attach();
                    document.body.appendChild(audioElement);
                }
            },
            onDataReceived: (messaggioRicevuto) => {
                // console.log("Evento/Testo ricevuto da LiveAvatar:", messaggioRicevuto);
            },
        });

        return true;
    } catch (e) {
        console.error("Errore durante l'inizializzazione:", e);
        UI.elements.messageInput.hidden = true;
        UI.mostraAlert(e.message, "danger");
        UI.elements.messageInput.value = "Errore durante il caricamento della chat, controlla la configurazione.";

        attesaSessione = null; // azzerando l'attesa un nuovo tentativo resta possibile

        //senza questo ritorno allo stato iniziale il pulsante di avvio e le scorciatoie restano nascosti
        //e l'utente non ha più nessun modo di riprovare
        UI.setChatState("idle");

        return false;
    }
}

/**
 * 2. Avvio normale della chat: il chatbot genera il saluto a partire dal prompt di benvenuto e l'avatar
 * lo pronuncia. Non viene creata nessuna chat, quella nasce col primo messaggio scritto dall'utente.
 * Avendo sempre un testo da far pronunciare, l'interrupt copre il messaggio di apertura dell'avatar
 * esattamente come avviene partendo da una scorciatoia.
 */
async function avviaChat() {
    if (isLoading) return;

    isLoading = true;
    UI.setControlsDisabled(true);

    try {
        //la sessione parte per prima e il benvenuto viene generato mentre la connessione si completa
        const [sessionePronta, benvenuto] = await Promise.all([avviaSessione(), richiediMessaggioBenvenuto()]);

        if (!sessionePronta || !benvenuto) return;

        UI.setChatState("speaking");
        await LiveKit.inviaMessaggio(benvenuto.messaggio_risposta);
        UI.setChatState("active");
    } catch (e) {
        console.error("Errore durante l'avvio della chat:", e);
        UI.setChatState("error");
        UI.mostraAlert("Errore durante l'avvio della chat.", "danger");
    } finally {
        isLoading = false;
        UI.setControlsDisabled(false);
        UI.focusInput();
    }
}

/**
 * 3. Logica di gestione invio del messaggio
 * @param messaggioUtente testo da inviare, se assente viene letto dalla textarea del form
 * @param idScorciatoia se valorizzato la domanda è il prompt della scorciatoia, recuperato dal controller
 */
async function preparaEInviaMessaggio(messaggioUtente, idScorciatoia = 0) {
    if (isLoading) return;

    isLoading = true;
    UI.setControlsDisabled(true);

    try {
        //se il messaggio utente non viene fornito allora prende il messaggio dal form di chat standard con quello che ha scritto l'utente
        if (!messaggioUtente && !idScorciatoia) {
            messaggioUtente = UI.elements.messageInput.value.trim();
        }

        if (!messaggioUtente && !idScorciatoia) {
            UI.setChatState("error");
            UI.mostraAlert("Inserisci un testo prima di inviare.", "warning");
            return;
        }

        //a sessione già aperta l'attesa è tutta sul chatbot, altrimenti lo stato lo gestisce connettiAvatar
        if (LiveKit.getRoomInstance()) UI.setChatState("generating");

        //la risposta del chatbot non dipende dalla stanza dell'avatar: le due attese scorrono insieme,
        //così il testo da pronunciare è pronto nell'istante in cui l'avatar diventa disponibile
        const [risposta, sessionePronta] = await Promise.all([richiediRispostaChatbot(messaggioUtente, idScorciatoia), avviaSessione()]);

        if (!risposta || !sessionePronta) return;

        UI.setChatState("speaking");

        const messaggioInviato = await LiveKit.inviaMessaggio(risposta.messaggio_risposta); // invio del messaggio alla sessione dell'avatar e start del text to speech, se il messaggio non è stato inviato correttamente, la funzione restituisce false

        if (!messaggioInviato) {
            console.error("messaggio non inviato correttamente", risposta);
            return;
        }

        const inputIdChat = document.getElementById("idChat");

        if (inputIdChat.value == 0) {
            // se l'hidden input dell'id chat è ancora 0 significa che la chat è stata appena creata e quindi va aggiornato per i successivi messaggi
            inputIdChat.value = risposta.id_chat;
            document.getElementById("operazioneControllerChat").value = "aggiungiMessaggio";
        }

        aggiornaElencoMessaggi(inputIdChat.value);

        UI.setChatState("active"); //pronti per la domanda successiva
    } catch (e) {
        console.error("Errore durante l'invio dei dati via LiveKit:", e);
        UI.setChatState("error");
        UI.mostraAlert("Errore di trasmissione.", "danger");
    } finally {
        //lo stato non viene reimpostato qui, altrimenti cancellerebbe i messaggi di errore già mostrati
        isLoading = false;
        UI.setControlsDisabled(false);
        UI.focusInput();
    }
}

/**
 * Chiede al controller la risposta del chatbot: al primo messaggio crea la chat, dai successivi la aggiorna.
 * Il body viene costruito a mano e non con FormData, che scarta i campi disabilitati e quindi lascerebbe
 * fuori il messaggio ogni volta che la textarea è disattivata, come accade a sessione in apertura.
 * @returns i dati della risposta, oppure null in caso di errore
 */
async function richiediRispostaChatbot(messaggioUtente, idScorciatoia = 0) {
    try {
        const res = await fetch(API_URL, {
            method: "POST",
            body: new URLSearchParams({
                operazione: document.getElementById("operazioneControllerChat").value,
                idChat: document.getElementById("idChat").value,
                messaggioUtente,
                idScorciatoia,
            }),
        });

        const risultato = await res.json(); //data contiene il messaggio gia come stringa da passare direttamente all'avatar

        if (!risultato.success) {
            console.error(risultato);
            UI.mostraAlert(risultato.error.message, "danger");

            return null;
        }
        console.log(risultato.data);
        UI.elements.messageInput.value = risultato.data.messaggio_utente;
        UI.elements.messageInput.focus();
        return risultato.data;
    } catch (e) {
        console.error(e);
        UI.mostraAlert("Errore durante la richiesta della risposta, riprova tra qualche istante.", "danger");

        return null;
    }
}

/**
 * Chiede al controller il saluto iniziale, generato dal prompt di benvenuto.
 * Non tocca il database: serve solo a dare all'avatar qualcosa da dire all'apertura della sessione.
 * @returns i dati della risposta, oppure null in caso di errore
 */
async function richiediMessaggioBenvenuto() {
    try {
        const res = await fetch(API_URL, {
            method: "POST",
            body: new URLSearchParams({
                operazione: "benvenuto",
            }),
        });

        const risultato = await res.json();

        if (!risultato.success) {
            console.error(risultato);

            return null;
        }

        return risultato.data;
    } catch (e) {
        console.error(e);

        return null;
    }
}

async function aggiornaElencoMessaggi(idChat) {
    try {
        const res = await fetch(API_URL, {
            method: "POST",
            body: new URLSearchParams({
                idChat,
                operazione: "aggiornaMessaggiChat",
            }),
        });

        const risultato = await res.json();
        console.log(risultato);

        if (risultato.success) {
            document.getElementById("elencoMessaggi").innerHTML = risultato.data.html;
        }
    } catch (e) {
        console.error(e);
    }
}

/**
 * 4. Avvio della chat da una scorciatoia. Il prompt non passa dal browser: lo recupera il controller
 * dall'id, quindi basta una sola richiesta e il testo da pronunciare arriva un viaggio prima.
 */
function iniziaChat(idScorciatoia) {
    console.log("iniziaChat", idScorciatoia);

    return preparaEInviaMessaggio("", idScorciatoia);
}

async function terminaChat() {
    // await LiveKit.terminaSessione();
    if (isLoading) {
        return;
    }

    isLoading = true;

    try {
        const res = await fetch(API_URL, {
            method: "post",
            body: new URLSearchParams({
                operazione: "termina",
            }),
        });

        const risultato = await res.json();
        console.log(risultato);

        if (risultato.success) {
            UI.setChatState("idle");
            UI.clearInput();
            UI.clearMessages();
        }
    } catch (e) {
        console.error(e);
        UI.mostraAlert("Errore durante il tentativo, riprova tra qualche istante");
    } finally {
        isLoading = false;
    }
    console.log("terminaChat");
}

//app.js è un modulo, quindi le sue funzioni non finiscono su window: serve esporla per l'onclick delle scorciatoie
window.iniziaChat = iniziaChat;

//creazione delle scorciatoie e append in html
async function stampaScorciatoie() {
    try {
        const res = await fetch(API_URL, {
            method: "POST",
            body: new URLSearchParams({
                operazione: "stampaScorciatoie",
            }),
        });

        const risultato = await res.json();

        console.log(risultato);

        if (risultato.success) {
            UI.elements.elencoScorciatoie.innerHTML = risultato.data;
        }
    } catch (e) {
        console.error(e);
    }
}

window.addEventListener("DOMContentLoaded", () => {
    console.log("loaded")
    stampaScorciatoie();
});
